<script setup>
import { cn } from '@/lib/utils'
import { provide, ref } from 'vue'

const props = defineProps({
  class: { type: String, default: '' },
})

const imageLoadingStatus = ref('idle')

provide('imageLoadingStatus', imageLoadingStatus)
</script>

<template>
  <div :class="cn('relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full', props.class)">
    <slot />
  </div>
</template>
